import { render, staticRenderFns } from "./HealthCertificateProvider.vue?vue&type=template&id=2dd29b8e"
import script from "./HealthCertificateProvider.vue?vue&type=script&lang=js"
export * from "./HealthCertificateProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports